import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useMemo, useCallback } from 'react';
import { useControlled } from '@landr/maestro';
import { getPositionFromValue, getValueFromPosition } from './helpers.es.js';

var useSlider = function useSlider(props) {
  var min = props.min,
      max = props.max,
      _props$width = props.width,
      width = _props$width === void 0 ? 300 : _props$width,
      onChange = props.onChange,
      onChangeEnd = props.onChangeEnd,
      defaultValue = props.defaultValue,
      value = props.value;

  var _useControlled = useControlled({
    defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : {
      min: min,
      max: max
    },
    value: value,
    onChange: onChange
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      currentValue = _useControlled2[0],
      updateValue = _useControlled2[1];

  var positions = useMemo(function () {
    var _currentValue$min, _currentValue$max;

    return {
      min: getPositionFromValue((_currentValue$min = currentValue === null || currentValue === void 0 ? void 0 : currentValue.min) !== null && _currentValue$min !== void 0 ? _currentValue$min : min, min, max, width),
      max: getPositionFromValue((_currentValue$max = currentValue === null || currentValue === void 0 ? void 0 : currentValue.max) !== null && _currentValue$max !== void 0 ? _currentValue$max : max, min, max, width)
    };
  }, [currentValue, min, max, width]);
  var updateMinFromPosition = useCallback(function (position) {
    var _currentValue$max2;

    var minPosition = getValueFromPosition(position, min, max, width);
    updateValue({
      min: minPosition,
      max: (_currentValue$max2 = currentValue === null || currentValue === void 0 ? void 0 : currentValue.max) !== null && _currentValue$max2 !== void 0 ? _currentValue$max2 : max
    });
  }, [min, max, currentValue, updateValue, width]);
  var updateMaxFromPosition = useCallback(function (position) {
    var _currentValue$min2;

    var maxPosition = getValueFromPosition(position, min, max, width);
    updateValue({
      min: (_currentValue$min2 = currentValue === null || currentValue === void 0 ? void 0 : currentValue.min) !== null && _currentValue$min2 !== void 0 ? _currentValue$min2 : min,
      max: maxPosition
    });
  }, [min, max, currentValue, updateValue, width]);
  var onMinChangeEnd = useCallback(function (position) {
    var _currentValue$max3;

    onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd({
      min: getValueFromPosition(position, min, max, width),
      max: (_currentValue$max3 = currentValue === null || currentValue === void 0 ? void 0 : currentValue.max) !== null && _currentValue$max3 !== void 0 ? _currentValue$max3 : max
    });
  }, [currentValue, min, max, width, onChangeEnd]);
  var onMaxChangeEnd = useCallback(function (position) {
    var _currentValue$min3;

    onChangeEnd === null || onChangeEnd === void 0 ? void 0 : onChangeEnd({
      min: (_currentValue$min3 = currentValue === null || currentValue === void 0 ? void 0 : currentValue.min) !== null && _currentValue$min3 !== void 0 ? _currentValue$min3 : min,
      max: getValueFromPosition(position, min, max, width)
    });
  }, [currentValue, min, max, width, onChangeEnd]);
  var minPosition = useMemo(function () {
    return getPositionFromValue(min, min, max, width);
  }, [min, max, width]);
  var maxPosition = useMemo(function () {
    return getPositionFromValue(max, min, max, width);
  }, [min, max, width]);
  return {
    currentValue: currentValue,
    positions: positions,
    minPosition: minPosition,
    maxPosition: maxPosition,
    updateMinFromPosition: updateMinFromPosition,
    updateMaxFromPosition: updateMaxFromPosition,
    onMinChangeEnd: onMinChangeEnd,
    onMaxChangeEnd: onMaxChangeEnd
  };
};

export { useSlider };